import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    width: 60,
    borderRadius: 5,
    color: 'white',
    fontSize: 14,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 15,
    padding: 8
  },
  value: {
    fontSize: '1.1rem',
    marginTop: 3
  }
})


class Measurement extends Component {
  render () {
    const { measurement, classes } = this.props
    return (
      <div className={classes.root}>
        <div>
          <div>{measurement.name.split('_').join(' ')}</div>
          <div className={classes.value}>{measurement.value}</div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Measurement)



// WEBPACK FOOTER //
// ./src/components/Timeline/Measurement.js